<template>
	<div class="thrd-scanner-list">
		<div class="thrd-scanner-con">
			<div class="title">
				<i class="x-icon-keys"></i><span class="x-tit-con">3D Scanner</span>
			</div>

			<div class="list">
				<img :src="solution_image_01" alt="Xhorse"/>
				<ul style="height: 15rem;">
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Apply to multi-dimensional measurement, deformation measurement,
							reverse engineering research, quality control and 3D digitalization of all walks of life.
						</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Superfast recognition speed, high accuracy results.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">A 3D Scanner fixed on the desk or handy portable 3D Scanner.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">Grating projection structured light/multi-line laser.</div>
					</li>
					<li>
						<div class="dot x-flow">·</div>
						<div class="ll x-flow">DLP/DOEC.</div>
					</li>
				</ul>
				<ul style="margin-top: 2.75rem">
					<li><img :src="solution_image_02" alt="Xhorse"/></li>
					<li><img :src="solution_image_03" alt="Xhorse"/></li>
				</ul>
			</div>
		</div>
	</div>
</template>

<script>

    import solution_image_01 from '@/assets/resource/images/solution/image_solutions_optics_01.png'
    import solution_image_02 from '@/assets/resource/images/solution/image_solutions_optics_02.png'
    import solution_image_03 from '@/assets/resource/images/solution/image_solutions_optics_03.png'
    export default {
        data(){
            return {
                solution_image_01: solution_image_01,
                solution_image_02: solution_image_02,
                solution_image_03: solution_image_03
            };
        }
    }

</script>

<style scoped="">
		.list > ul:last-child > li:nth-child(2) {
			margin-left: 1.5rem;
		}

		.list > ul:last-child > li > img {
			width: 100%;
		}

		.list > ul:last-child > li {
			width: calc((100% - 1.5rem) / 2);
			height: 13.25rem;
			float: left;
		}

		.list > ul:last-child {
			width: 100%;
			height: 14.25rem;
		}

		.dot {
			width: .625rem;
		}

		.ll {
			width: calc(100% - .625rem);
			border: none;
			font-size: 1rem;
			color: #515555;
			letter-spacing: 0;
			text-align: justify;
			line-height: 1.5rem;
			margin-bottom: 1.375rem;
		}

		.list > ul:first-child > li {
			width: 100%;
			text-align: left;
		}

		.list > ul:nth-child(1) {
			width: 100%;
			height: 15rem;
			margin-bottom: 2.75rem;
		}

		.list > img:first-child {
			width: 100%;
			margin-bottom: 2.75rem;
		}

		.list {
			width: 54.5rem;
			height: 56.375rem;
			border: none;
			margin-left: 7rem;
		}

		.thrd-scanner-list {
			width: 100%;
			height: 60.625rem;
			border: none;
		}

		.thrd-scanner-con {
			width: 100%;
			height: 72.875rem;
			border: none;
			margin-left: 0;
		}

		.x-tit-con {
			font-size: 1.5rem;
			color: #3B3A38;
			line-height: 3.25rem;
		}

		.title {
			width: calc(100% - 3.25rem);
			text-align: left;
			margin-left: 3.25rem;
			margin-top: 2.75rem;
			margin-bottom: 2.75rem;
		}

		.x-icon-keys {
			display: inline-block;
			content: url("../../../assets/resource/icons/ico_solutions.png");
			width: 2.75rem;
			height: 2.75rem;
			position: relative;
			top: .625rem;
			margin-right: 1rem;
		}
</style>


// WEBPACK FOOTER //
// src/components/zh-cn/solution/solution-3d-scanner.vue